// @flow
import * as React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import Radium from 'radium';
import { FormGroup, Label, Input } from 'reactstrap';

type Props = {
  label: string,
  options: { [optionId: string]: boolean },
  onOptionsSelected: (optionIds: Array<string>) => void,
  initialSelections?: { [optionId: string]: boolean },

  // recompose
  selectedOptions: { [optionId: string]: boolean },
  handleSelectedOptionsChange: (optionId: string, selected: boolean) => void,
};

const crunchOptions = (selectedOptions: {
  [optionId: string]: boolean,
}): Array<string> => {
  return Object.keys(selectedOptions).filter(
    optionId => selectedOptions[optionId]
  );
};

class OptionsSelector extends React.Component<Props> {
  componentDidMount() {
    const { selectedOptions, onOptionsSelected } = this.props;
    onOptionsSelected(crunchOptions(selectedOptions));
  }

  render() {
    const {
      label,
      options,
      selectedOptions,
      handleSelectedOptionsChange,
    } = this.props;
    return (
      <FormGroup>
        <Label>{label}</Label>
        {Object.keys(options).map(optionId => (
          <div key={optionId}>
            <Label check>
              <Input
                type="checkbox"
                checked={selectedOptions[optionId]}
                onChange={event =>
                  handleSelectedOptionsChange(optionId, event.target.checked)
                }
              />{' '}
              {options[optionId]}
            </Label>
          </div>
        ))}
      </FormGroup>
    );
  }
}

const OptionsSelectorContainer = compose(
  withState(
    'selectedOptions',
    'onSelectedOptionsChange',
    ({ options, initialSelections }) =>
      Object.keys(options).reduce(
        (acc, id) => ({
          ...acc,
          [id]: (initialSelections || {})[id] || false,
        }),
        {}
      )
  ),
  withHandlers({
    handleSelectedOptionsChange: ({
      selectedOptions,
      onOptionsSelected,
      onSelectedOptionsChange,
    }) => (optionId: string, selected: boolean) => {
      const newSelectedOptions = {
        ...selectedOptions,
        [optionId]: selected,
      };
      onSelectedOptionsChange(newSelectedOptions);
      onOptionsSelected(crunchOptions(newSelectedOptions));
    },
  }),
  Radium
)(OptionsSelector);

export default OptionsSelectorContainer;



// WEBPACK FOOTER //
// ./src/components/OptionsSelector/OptionsSelector.js